import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'resetBtn',
    'searchText',
    'searchForm',
    'orderBy',
    'adminSearchForm',
    'adminSearchInput',
    'userSearchForm',
    'userSearchInput',
    'reportSearchInput',
    'reportSearchForm',
    'logSearchForm',
    'logNameInput',
    'logIpInput',
    'historySearchForm',
    'historySearchInput',
    'newsSearchForm',
    'newsSearchInput',
  ];

  order() {
    this.searchFormTarget.submit();
  }

  resetData() {
    this.searchTextTarget.value = '';
    this.searchFormTarget.submit();
  }

  adminResetData(e) {
    this.adminSearchInputTarget.value = '';
    this.adminSearchFormTarget.submit();
  }

  userResetData() {
    this.userSearchInputTarget.value = '';
    this.userSearchFormTarget.submit();
  }

  reportResetData() {
    this.reportSearchInputTarget.value = '';
    this.reportSearchFormTarget.submit();
  }

  logNameResetData() {
    this.logNameInputTarget.value = '';
    this.logSearchFormTarget.submit();
  }

  logIpResetData() {
    this.logIpInputTarget.value = '';
    this.logSearchFormTarget.submit();
  }

  historyResetData() {
    this.historySearchInputTarget.value = '';
    this.historySearchFormTarget.submit();
  }

  newsResetData() {
    this.newsSearchInputTarget.value = '';
    this.newsSearchFormTarget.submit();
  }
}
